// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"c27d18e2","77":"e10d4702","115":"ba25f6ef","222":"22024047","247":"ce90af99","280":"87264c5b","320":"5479cdfe","354":"bbbe59ac","444":"31bd161e","526":"debfffd8","567":"b6fe03cc","716":"76342fe0","779":"101af440","860":"4d82ad21","867":"a8cdc4e9"}[chunkId] + ".chunk.js";
};